// extracted by mini-css-extract-plugin
module.exports = {"root":"ClientCreditCards_root__7-CPB","cards":"ClientCreditCards_cards__1ec-B","empty":"ClientCreditCards_empty__3s-B2"};